import { render, staticRenderFns } from "./filtersTable.vue?vue&type=template&id=4ae2b6a0&scoped=true"
import script from "./filtersTable.vue?vue&type=script&lang=js"
export * from "./filtersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2b6a0",
  null
  
)

export default component.exports